"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
interface NftPickerStatusProps {
  helperState: {
    tone: "success" | "error" | "muted";
    text: string;
  };
  helperMessageId: string;
}
export function NftPickerStatus(t0) {
  const $ = _c(8);
  const {
    helperState,
    helperMessageId
  } = t0;
  const t1 = helperState.tone === "success";
  const t2 = helperState.tone === "error";
  const t3 = helperState.tone === "muted";
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = clsx("tw-min-h-[1.25rem] tw-text-xs tw-font-medium", {
      "tw-text-emerald-300": t1,
      "tw-text-red-300": t2,
      "tw-text-iron-300": t3
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const helperClassName = t4;
  let t5;
  if ($[4] !== helperClassName || $[5] !== helperMessageId || $[6] !== helperState.text) {
    t5 = <output id={helperMessageId} className={helperClassName} aria-live="polite">{helperState.text}</output>;
    $[4] = helperClassName;
    $[5] = helperMessageId;
    $[6] = helperState.text;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}